// src/awsConfig.js
import { CognitoUserPool } from "amazon-cognito-identity-js";

// Shared x20 family Cognito user pool (same pool used by all x20 sites —
// one account works across the family).
const poolData = {
  UserPoolId: "us-east-1_EHLNaw2f5",
  ClientId: "2qlo02casnk0gthkjem39uvlfj",
};

export const userPool = new CognitoUserPool(poolData);
